// import React, { useState, useEffect } from 'react';
// import Slider from 'react-slick';
// import axios from 'axios';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import "./Imageslide.css"
// import { useNavigate } from 'react-router-dom';


// const ImageSlider = () => {
//   const [images, setImages] = useState([]);
//   const [width, setWidth] = useState(window.innerWidth);
//   const [mobileImages, setMobileImages] = useState([]);
//   const navigate = useNavigate();


//   // Fetch images from the API
//   const fetchImages = async () => {
//     try {
//       const response = await fetch(
//         // "https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/slider-fetch"
//         "https://ub3uejdxxh.execute-api.ap-south-1.amazonaws.com/dev/slider-fetch"
//       );
//       const data = await response.json();
//         // Log the full response for debugging

//       // const cleanedBody = data.body.replace(/NaN/g, "null");
//       // const parsedData = JSON.parse(cleanedBody);
//       // console.log("laptop images:", parsedData);


//       // Parse the body, which is a string
//       // const imageData = JSON.parse(data.body);

//       // Ensure that the data is an array
//       // if (Array.isArray(imageData)) {
//       //   const imageURLs = imageData.map((item) => item.largeImageURL);
//       //   // console.log("laptop images:", imageURLs);
//       //   setImages(imageURLs);
//       // } 
//       if(Array.isArray(data)){
//         setImages(data);
//       }
//       else {
//         console.error("API response body is not an array:", data);
//       }
//     } catch (error) {
//       console.error("Error fetching images:", error);
//     }
//   };

//   const fetchMobileImages = async () => {
//     try {
//       const response = await fetch(
//         "https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/slider-fetch-mobile"
//       );
//       const data = await response.json();


//       const cleanedBody = data.body.replace(/NaN/g, "null");
//       const parsedData = JSON.parse(cleanedBody);
//       // console.log("mobile images ", parsedData);

//       // const imageData = JSON.parse(data.body);

//       // // Ensure that the data is an array
//       // if (Array.isArray(imageData)) {
//       //   const imageURLs = imageData.map((item) => item.largeImageURL);
//       //   // console.log("mobile images",imageURLs)
//       //   setMobileImages(imageURLs);
//       // } 
//       if(Array.isArray(parsedData)){
//         setMobileImages(parsedData);
//       }
//       else {
//         console.error("API response body is not an array:", parsedData);
//       }
//     } catch (error) {
//       console.error("Error fetching images:", error);
//     }
//   }
//   // Fetch images on component mount
//   useEffect(() => {
//     fetchImages();
//     fetchMobileImages();
//     const handleResize = () => setWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//   }, []);

//   // Settings for the slick slider
//   const settings = {
//     // dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     // arrows: true,
//     // nextArrow: <div className="slick-next">Next</div>,
//     // prevArrow: <div className="slick-prev">Prev</div>,
//   };

//   const handleBannerClick = (imageData) => {
//     if(imageData?.field === 'Categories'){
//       navigate(`/category/${imageData?.value}`);
//     }else if (imageData?.field === 'Model'){
//       navigate(`/product/${imageData?.value}`);
//     } else{
//       navigate(`/search/${imageData?.value}`);
//     }
//   }
//   return (
//     <div className="image-slider-page-image-container">
//       {
//         (width > 768 && images.length > 0) ? (
//           <Slider {...settings}>
//             {images?.map((imageURL, index) => (
//               <div key={index}>
//                 <img
//                   src={imageURL?.largeImageURL}
//                   alt={`slider-${index}`}
//                   className="image-slider-page-image"
//                   onClick={() => handleBannerClick(imageURL)}
//                 />
//               </div>
//             ))}
//           </Slider>
//         ) : ( width > 768 &&
//           <p className="text-center text-red-600">Loading images...</p>
//         )
//       }
//       {
//         (width <= 768 && mobileImages.length > 0) ? (
//           <Slider {...settings}>
//             {mobileImages?.map((imageURL, index) => (
//               <div key={index}>
//                 <img
//                   src={imageURL?.largeImageURL}
//                   alt={`slider-${index}`}
//                   className="image-slider-page-image"
//                   onClick={() => handleBannerClick(imageURL)}
//                 />
//               </div>
//             ))}
//           </Slider>
//         ) : (width <= 768 &&
//           <p className="text-center text-red-600">Loading images...</p>
//         )
//       }
//     </div>
//   );
// };

// export default ImageSlider;


import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import axios from 'axios';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Imageslide.css"
import { useNavigate } from 'react-router-dom';

// Custom arrow components
const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className="custom-prev-arrow"
      onClick={onClick}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </div>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className="custom-next-arrow"
      onClick={onClick}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 18l6-6-6-6" />
      </svg>
    </div>
  );
};

const ImageSlider = () => {
  const [images, setImages] = useState([]);
  const [width, setWidth] = useState(window.innerWidth);
  const [mobileImages, setMobileImages] = useState([]);
  const navigate = useNavigate();


  // Fetch images from the API
  const fetchImages = async () => {
    try {
      const response = await fetch(
        "https://ub3uejdxxh.execute-api.ap-south-1.amazonaws.com/dev/slider-fetch"
      );
      const data = await response.json();

      if (Array.isArray(data)) {
        setImages(data);
      }
      else {
        console.error("API response body is not an array:", data);
      }
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  const fetchMobileImages = async () => {
    try {
      const response = await fetch(
        "https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/slider-fetch-mobile"
      );
      const data = await response.json();

      const cleanedBody = data.body.replace(/NaN/g, "null");
      const parsedData = JSON.parse(cleanedBody);

      if (Array.isArray(parsedData)) {
        setMobileImages(parsedData);
      }
      else {
        console.error("API response body is not an array:", parsedData);
      }
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  }

  // Fetch images on component mount
  useEffect(() => {
    fetchImages();
    fetchMobileImages();
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Settings for the slick slider
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />
  };

  // const handleBannerClick = (imageData) => {
  //   if (imageData?.field === 'Categories') {
  //     navigate(`/category/${imageData?.value}`);
  //   } else if (imageData?.field === 'Model') {
  //     navigate(`/product/${imageData?.value}`);
  //   } else {
  //     navigate(`/search/${imageData?.value}`);
  //   }
  // }

  const handleBannerClick = (imageData) => {
    let url;
    if (imageData?.field === 'Categories') {
      url = `/category/${imageData?.value}`;
    } else if (imageData?.field === 'Model') {
      url = `/product/${imageData?.value}`;
    } else {
      url = `/search/${imageData?.value}`;
    }

    // Open the URL in a new tab
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  return (
    <div className="image-slider-page-image-container">
      {
        (width > 768 && images.length > 0) ? (
          <Slider {...settings}>
            {images?.map((imageURL, index) => (
              <div key={index}>
                <img
                  src={imageURL?.largeImageURL}
                  alt={`slider-${index}`}
                  className="image-slider-page-image"
                  onClick={() => handleBannerClick(imageURL)}
                />
              </div>
            ))}
          </Slider>
        ) : (width > 768 &&
          <p className="text-center text-red-600">Loading images...</p>
        )
      }
      {
        (width <= 768 && mobileImages.length > 0) ? (
          <Slider {...settings}>
            {mobileImages?.map((imageURL, index) => (
              <div key={index}>
                <img
                  src={imageURL?.largeImageURL}
                  alt={`slider-${index}`}
                  className="image-slider-page-image"
                  onClick={() => handleBannerClick(imageURL)}
                />
              </div>
            ))}
          </Slider>
        ) : (width <= 768 &&
          <p className="text-center text-red-600">Loading images...</p>
        )
      }
    </div>
  );
};

export default ImageSlider;